/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CommentRectIcon16Light } from './CommentRectIcon16Light';
import { CommentRectIcon16Regular } from './CommentRectIcon16Regular';
import { CommentRectIcon16Solid } from './CommentRectIcon16Solid';
import { CommentRectIcon20Light } from './CommentRectIcon20Light';
import { CommentRectIcon20Regular } from './CommentRectIcon20Regular';
import { CommentRectIcon20Solid } from './CommentRectIcon20Solid';
import { CommentRectIcon24Regular } from './CommentRectIcon24Regular';
import { CommentRectIcon24Solid } from './CommentRectIcon24Solid';
import { CommentRectIcon32Regular } from './CommentRectIcon32Regular';
import { CommentRectIcon64Regular } from './CommentRectIcon64Regular';
var sizes = {
    16: {
        light: CommentRectIcon16Light,
        regular: CommentRectIcon16Regular,
        solid: CommentRectIcon16Solid,
    },
    20: {
        light: CommentRectIcon20Light,
        regular: CommentRectIcon20Regular,
        solid: CommentRectIcon20Solid,
    },
    24: {
        regular: CommentRectIcon24Regular,
        solid: CommentRectIcon24Solid,
    },
    32: {
        regular: CommentRectIcon32Regular,
    },
    64: {
        regular: CommentRectIcon64Regular,
    },
};
export var CommentRectIcon = forwardRef('CommentRectIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
